export const SET_DRAWER_STATE = "SET_DRAWER_STATE";
export const SET_LIST_VIEW_STATE = "SET_LIST_VIEW_STATE";
export const SET_SIDE_LINK_DATA = "SET_SIDE_LINK_DATA";
export const SET_SELECTED_NOTES = "SET_SELECTED_NOTES";
export const SET_NOTES = "SET_NOTES";
export const SET_TRASH_NOTES = "SET_TRASH_NOTES";
